import qualityEventsHelpers from '../quality-events.helpers';

export const MATERIAL_FEEDBACK_QUALITY_EVENTS = {
    updateCreateFeedback(feedbackId: number, type: string, materialId?: number) {
        qualityEventsHelpers.track({
            extra: JSON.stringify({
                material_id: materialId,
                review_id: feedbackId
            }),
            type
        });
    }
};
